jQuery(document).ready(function($){
   


  function processData(allText) {
      var allTextLines = allText.split(/\r\n|\n/);
      var headers = allTextLines[0].split(',');
      var lines = [];
  
      for (var i=1; i<allTextLines.length; i++) {
          var data = allTextLines[i].split(',');
          if (data.length == headers.length) {
  
              var tarr = [];
              for (var j=0; j<headers.length; j++) {
                  tarr.push(headers[j]+":"+data[j]);
              }
              lines.push(tarr);
          }
      }

      return lines
      // alert(lines);
  }
  
  if($('.smashing-nki').length > 0){
    const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];

    var items;
    $.ajax({
      type: "GET",
      url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRLTGazoIhT3CIINbuCEFE7ZX0BsrfUgmxBzfE4fwksmVPgIf6ztp4E3qdQ11TS_SxHVNe8frxsL6Qw/pub?gid=0&single=true&output=csv",
      dataType: "text",
      success: function(data) {
        
        items = processData(data);
        
        var html = '<h4>Non-Active Ingredients</h4>'
        html += '<div class="nai-header">'
        alphabet.forEach((val, i) => {
          html += '<a class="nai-anchor ' + (i == 0 ? 'active' : '') + '" href="#" data-id="' + val + '">' + val + '</a>'
        })
        html += '</div>'
    
        html += '<div class="nai-body">'
        html += getData('a')
        html += '</div>'
    
        $('.smashing-nki').html(html)
      }
   });
    
  }

  $('body').on('click', '.smashing-nki .nai-anchor', function(e){
    e.preventDefault()
    $(this).addClass('active').siblings('a').removeClass('active')
    var pager = $(this).attr('data-id')
    $('.nai-body').html(getData(pager))
  })


  function getData(pager = 'a'){
    var result = '';
    if (items.length > 0){
      items.forEach(function(val, i){
        let title = val[0].replace('Title:', '')
        let title_first = title.charAt(0).toLowerCase() 

        let desc = val[1].replace('Description:', '')

        if(pager == title_first){
          
          result += '<div class="res-item">'
          result += '<div class="ri-title">' + title + '</div>'
          result += '<div class="ri-desc">' + desc + '</div>'
          result += '</div>'
        }
      })
    }
        
    return result
  }


  if($('.smashing-collection-az-filter').length > 0){
    const alphabet = [...'abcdefghijklmnopqrstuvwxyz'];
    var html = '';
    var id = $(this).attr('data-id')
    html += '<div class="nai-header">'
    alphabet.forEach((val, i) => {
      html += '<a class="nai-anchor ' + (i == 0 ? 'active' : '') + '" href="#" data-id="' + val + '">' + val + '</a>'
    })
    html += '</div>'
    $('.smashing-collection-az-filter').html(id, html)
    getData2(id, 'a')
  }

  $('body').on('click', '.smashing-collection-az-filter .nai-anchor', function(e){
    e.preventDefault()
    var id = $(this).parent().parent().attr('data-id')
    $(this).addClass('active').siblings('a').removeClass('active')
    var pager = $(this).attr('data-id')
    getData2(id, pager)
  })

  function getData2(id="", pager = "a"){
    console.log(id)
    var html = '#'+id
    $(html).find('.product-card').each(function(){
      var title = $(this).find('.product-card__title').text('')
      let title_first = title.charAt(0).toLowerCase() 
      if(pager == title_first){
        $(this).fadeIn(0)
      }else{
        $(this).fadeOut(0)
      }
    })
  }
})